import React, { Fragment } from "react";
import PropTypes from "prop-types";
import CustomPropTypes from "../../utils/customPropTypes";
import style from "../../../scss/components/Applications/ApplicationsList";
import SafeHTML from "../SafeHTML";
import ImageBlock from "../ImageBlock";
import closeButton from "../../../img/close_button.png";
export default class Applications extends React.Component {
  static propTypes = {
    catcards: PropTypes.arrayOf(
      PropTypes.shape({
        category_page: PropTypes.shape({
          name: PropTypes.string,
          icon: CustomPropTypes.Image,
        }),
      })
    ),
    cards: PropTypes.arrayOf(
      PropTypes.shape({
        sub_category_page: PropTypes.shape({
          title: PropTypes.string,
          url: PropTypes.string,
        }),
        applications: PropTypes.arrayOf(
          PropTypes.shape({
            title: PropTypes.string,
            url: PropTypes.string,
          })
        ),
      })
    ),
    eyebrow: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.state = {
      marginBottoms: {},
      isColorFlexL2Page: false,
      isColorFlexL2Tomato: false,
      applicationTile:false,
    };
  }

  componentDidMount() {
    let isColorFlexL2 = window.location.pathname.includes("/colorflex-l2") && !window.location.pathname.includes("colorflex-l2-tomato");
    let isColorFlexL2Tomato = window.location.pathname.includes('colorflex-l2-tomato');
    if (isColorFlexL2) {
      this.setState({ 
        isColorFlexL2Page: isColorFlexL2,
        isColorFlexL2Tomato: isColorFlexL2Tomato 
      });
    }

    const pathname = window.location.pathname;
    let pageType = "";

    if (pathname.includes("colorflex-l2-tomato")) {
      pageType = "tomato";
    } else if (pathname.includes("colorflex-l2")) {
      pageType = "l2";
    }

    this.setState({ pageType });
  }
  // Dynamically calculate and set padding-bottom on hover
  handleMouseEnter = (index) => {
    if (this.state.isColorFlexL2Page) {
      this.setState({applicationTile:true})
      setTimeout(() => {
        const appShowElements = document.querySelectorAll(".apps-show")[index];
        appShowElements.style.display = "block";

        if (appShowElements) {
          const appShowHeight = appShowElements.scrollHeight;

          if (appShowHeight > 0) {
            this.setState((prevState) => ({
              marginBottoms: {
                ...prevState.marginBottoms,
                [index]: `${appShowHeight}px`,
              },
            }));
          }
        }
      }, 0);
    }
  };

  // Reset padding-bottom on mouse leave
  handleMouseLeave = (index) => {
    if (this.state.isColorFlexL2Page) {
      this.setState({applicationTile:false})
      const appShowElements = document.querySelectorAll(".apps-show")[index];
      appShowElements.style.display = "none";

      setTimeout(() => {
        // appShowElements.style.display = "none";
      }, 10);

      this.setState((prevState) => ({
        marginBottoms: {
          ...prevState.marginBottoms,
          [index]: "0px",
        },
      }));
    }
  };

  render() {
    let self = this;
    return (
      <div>
        <section
          id="products-detail-application-section"
          className="applications-section"
        >
          <div className="container">
            <div className="apps-list-head">
              <h2 style={{ textAlign: "center" }} className="app-info-title">
                {this.props.eyebrow}
              </h2>
              {this.state.pageType === "l2" && (
                <p style={{ textAlign: "center" }} className="application_description whats-in-the-box-sub-text">
                  Whether you’re measuring opaque solids, liquids, powders, granules, pellets, or translucent materials, ColorFlex L2 has you covered.
                </p>
              )}
              {this.state.pageType === "tomato" && (
                <p style={{ textAlign: "center" }} className="application_description whats-in-the-box-sub-text">
                  Whether you’re measuring opaque solids, liquids, powders, granules, pellets, or translucent materials, ColorFlex L2 Tomato has you covered.
                </p>
              )}
            </div>
            <ul className="applications-list">
              {this.props.catcards.map((objApp, index) => (
                <div
                  key={index}
                  className="product-application-wrapper"
                //   onMouseEnter={() => this.handleMouseEnter(index)}
                //   onMouseLeave={() => this.handleMouseLeave(index)}
                //   onTouchStart={() => this.handleMouseEnter(index)}
                //   onTouchEnd={() => this.handleMouseLeave(index)}
                >
                  {objApp && (
                    <>
                      <li
                        className="application"
                         onMouseEnter={() => this.handleMouseEnter(index)}
                         onMouseLeave={() => this.handleMouseLeave(index)}
                         onClick={() => {this.state.applicationTile ? this.handleMouseLeave(index) : this.handleMouseEnter(index)}}
                        //  onTouchEnd={() => this.handleMouseLeave(index)}
                        style={{
                          maxWidth:
                            this.props.catcards.length <= 1 ? "555px" : "",
                          marginBottom:
                            this.state.marginBottoms[index] || "0px",

                          transition: "margin-bottom 0.6s ease", // Smooth transition for the padding change
                          position: "relative",
                        }}
                      >
                        <div className="grow">
                          <span className="applications-icon">
                            <ImageBlock
                              image={objApp.category_page.data.icon}
                              addWrapper={false}
                            />
                          </span>
                          <div className="category-title">
                            {objApp.category_page.title}
                          </div>
                          <div
                            className={
                              this.state.isColorFlexL2Page
                                ? " colorflex-l2-app-show apps-show"
                                : "apps-show other-app-show"
                            }
                          >
                            {objApp.cards.map((pageobj, index) => (
                              <>
                                {pageobj.sub_category_page ? (
                                  <>
                                    <li
                                      key={index}
                                      className="apps-in-subcategory"
                                    >
                                      <SafeHTML>
                                        <div className="sub-category-title">
                                          {pageobj.sub_category_page.title}
                                        </div>
                                      </SafeHTML>
                                      {pageobj.applications.map(
                                        (Appobj, index) => (
                                          <>
                                            {Appobj && (
                                              <li
                                                key={index}
                                                className="app-list"
                                              >
                                                <SafeHTML>
                                                  <a
                                                    className="applications-title"
                                                    href={Appobj.url}
                                                  >
                                                    {Appobj.name}
                                                    <i
                                                      style={{
                                                        marginRight: "25px",
                                                        marginTop: "5px",
                                                      }}
                                                      class="icon icon-direction-right app"
                                                    ></i>
                                                  </a>
                                                </SafeHTML>
                                              </li>
                                            )}
                                          </>
                                        )
                                      )}
                                    </li>
                                  </>
                                ) : (
                                  pageobj.applications.map((Appobj, index) => (
                                    <>
                                      {Appobj && (
                                        <li
                                          key={index}
                                          className="app-list-detail"
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            gap: "30px",
                                          }}
                                        >
                                          <SafeHTML>
                                            <a
                                              className="applications-title"
                                              href={Appobj.url}
                                            >
                                              {Appobj.name}
                                            </a>
                                          </SafeHTML>
                                          <i
                                            style={{
                                              marginRight: "25px",
                                              marginTop: "5px",
                                            }}
                                            class="icon icon-direction-right app"
                                          ></i>
                                        </li>
                                      )}
                                    </>
                                  ))
                                )}
                              </>
                            ))}
                          </div>
                          {/* <i class="icon icon-direction-right cat"></i> */}
                        </div>
                      </li>
                    </>
                  )}
                </div>
              ))}
            </ul>
          </div>
        </section>
      </div>
    );
  }
}
